import { z } from 'zod';

import { richTextElementSchema } from './rich-text';

export const textBlockSchema = z.object({
    blockId: z.uuid(),
    content: z.array(richTextElementSchema).min(1),
    type: z.literal('text'),
});

export type TextBlock = z.infer<typeof textBlockSchema>;
